module.exports = __webpack_public_path__ + "static/img/pn-333.31e23af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pn-333.jpg
// module id = whLt
// module chunks = 1